import styled from 'styled-components';

export const LinkContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;